/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import { Container, Button, Modal } from "react-bootstrap";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import Anchor from "../elements/Anchor";

const Header = ({ settings, thinHeader }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuItems = settings.data.body;
  return (
    <>
      <header>
        <Container
          className={`header-container py-3 py-sm-${thinHeader ? "3" : "4"
            } py-lg-${thinHeader ? "3" : "5"
            } d-flex justify-content-between align-items-center`}
        >
          <Anchor href="/">
            <GatsbyImage
              image={settings.data.logo.gatsbyImageData}
              alt="logo"
              className="logo-btn"
            />
          </Anchor>
          <Button
            variant="link"
            className="menu-icon"
            onClick={() => setIsMenuOpen(true)}
          >
            <span className="bar1" />
            <span className="bar2" />
            <span className="bar3" />
          </Button>
        </Container>
      </header>
      <Modal
        show={isMenuOpen}
        fullscreen
        className="menu bg-dark menu-animation"
        onHide={() => setIsMenuOpen(false)}
      >
        <Modal.Body className="bg-dark text-light">
          <Container>
            <div className="d-flex justify-content-between justify-content-md-end mb-2 mb-sm-5">
              <Button
                variant="link"
                onClick={() => setIsMenuOpen(false)}
                className="d-md-none"
              >
                <Anchor href="/">
                  <GatsbyImage
                    image={settings.data.logo.gatsbyImageData}
                    alt="logo"
                    className="logo-btn"
                  />
                </Anchor>
              </Button>
              <Button variant="link" onClick={() => setIsMenuOpen(false)}>
                <StaticImage
                  src="../../images/closeX.svg"
                  alt="close button"
                  className="close-btn"
                />
              </Button>
            </div>
            <div className="d-flex justify-content-between">
              <Button
                variant="link"
                onClick={() => setIsMenuOpen(false)}
                className="d-none d-md-flex"
              >
                <Anchor href="/">
                  <GatsbyImage
                    image={settings.data.logo.gatsbyImageData}
                    alt="logo"
                    className="logo-btn"
                  />
                </Anchor>
              </Button>
              <div className="ps-4 ps-sm-5 pe-md-5">
                <div
                  key={menuItems[0].primary.label}
                  className="pe-md-5"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <Anchor href={menuItems[0].primary.link.url}>
                    <h3 className="text-light mt-4">
                      <span className="link-underline-hover underline-light menu-item menu-item-1">
                        {menuItems[0].primary.label}
                      </span>
                    </h3>
                  </Anchor>
                </div>
                <div key={menuItems[1].primary.label} className="pe-md-5 collection-menu-items">
                  <Anchor href={menuItems[1].primary.link.url}>
                    <h3 className="text-light mt-4">
                      <span className="menu-item menu-item-2">
                        {menuItems[1].primary.label}
                      </span>
                    </h3>
                  </Anchor>
                  {menuItems[1].items.map((item, i) => {
                    return (
                      <div key={item.sub_label}>
                        <Anchor href={item.sub_link.url}>
                          <h4
                            className="text-light mb-3 mb-sm-4"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            <span className={`link-underline underline-light menu-item menu-item-${i + 3}`}>
                              {item.sub_label}
                            </span>
                          </h4>
                        </Anchor>
                      </div>
                    );
                  })}
                </div>
                <div
                  key={menuItems[2].primary.label}
                  className="pe-md-5"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <Anchor href={menuItems[2].primary.link.url}>
                    <h3 className="text-light mt-4">
                      <span className="link-underline-hover underline-light menu-item menu-item-13">
                        {menuItems[2].primary.label}
                      </span>
                    </h3>
                  </Anchor>
                </div>
              </div>
            </div>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
